var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "mb-3" },
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("p", { staticClass: "pt-3 border-top" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("e-sign-package.messages.selectAgentToSendPackage")
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("agents-select", {
            ref: "agentsSelect",
            attrs: {
              multiple: false,
              value: _vm.requesterAgent,
              required: "",
              "avatar-class": "col-lg-1",
              "dropdown-parent": "#e-sign-modal-wrapper",
            },
            on: { loading: _vm.handleLoadingAgents, change: _vm.handleChange },
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text-danger" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("e-sign-package.messages.selectAgentNote")) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }